import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

@Directive({
    selector: '[msTreeDisplayAfter]',
    standalone: true,
})
export class TreeDisplayAfterDirective implements OnInit, OnDestroy {
    @Input('msTreeDisplayAfter') displayAfter: number;
    private displayStyle: string;
    private timer: any;

    constructor(private elementRef: ElementRef) {
        this.displayStyle = this.elementRef.nativeElement.style.display;
    }

    ngOnInit(): void {
        if (this.displayAfter > 0) {
            this.elementRef.nativeElement.style.display = 'none';
            this.timer = setTimeout(() => {
                this.elementRef.nativeElement.style.display = this.displayStyle;
            }, this.displayAfter);
        }
    }

    ngOnDestroy(): void {
        clearTimeout(this.timer);
    }
}
